import React from "react";
import "./promosection.css";
import "./../style/common.css";
import { Link } from "react-router-dom";

const PromoSection = () => {
  return (
    <div>
      {/* Section 2: Delivery */}
      <div className="delivery-main">
        <div className="promo-delivery">
          <div className="delivery-image">
            <img src="/Images/food delivery in mandurah.webp" alt="Delivery" loading="lazy" />
          </div>
          <div className="delivery-text">
            <h3>45 Minutes Delivery</h3>
            <p>
              We bring your favourite meals- hot and fresh to your doorstep in
              just 45 Minutes. No delays and No compromises.
            </p>
           <Link to="/view-our-menu"> <button className="btn-red">ORDER NOW</button> </Link> 
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromoSection;
